import React from "react";
import Slider from "./Slider";
import Budget from "./Budget";
import Contract from "./Contract";
import SingleChoice from "./Text/SingleChoice";
import MultiChoice from "./Text/MultiChoice";

const Answer = (props) => {
  switch (props.type) {
    case "slider":
      return <Slider {...props} />;

    case "budget":
      return <Budget {...props} />;

    case "contract":
      return <Contract {...props} />;

    default:
      return props.multiChoice ? (
        <MultiChoice {...props} />
      ) : (
        <SingleChoice {...props} />
      );
  }
};

export default Answer;
